// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Caml_array = require("bs-platform/lib/js/caml_array.js");
var ArrayLabels = require("bs-platform/lib/js/arrayLabels.js");
var ArrayF$BsBastet = require("./ArrayF.bs.js");

function length(prim) {
  return prim.length;
}

var make = Caml_array.caml_make_vect;

var map = ArrayLabels.map;

function mapi(f, arr) {
  return ArrayLabels.mapi((function (index, e) {
                return Curry._2(f, e, index);
              }), arr);
}

var fold_left = ArrayLabels.fold_left;

var every = ArrayLabels.for_all;

function slice(start, end_, arr) {
  return ArrayLabels.sub(arr, start, end_ - start | 0);
}

var A = ArrayF$BsBastet.Make({
      length: length,
      make: make,
      append: ArrayLabels.append,
      map: map,
      mapi: mapi,
      fold_left: fold_left,
      every: every,
      slice: slice
    });

var zip_with = A.zip_with;

var zip = A.zip;

var Functor = A.Functor;

var Alt = A.Alt;

var Apply = A.Apply;

var Applicative = A.Applicative;

var Monad = A.Monad;

var Foldable = A.Foldable;

var Unfoldable = A.Unfoldable;

var Traversable = A.Traversable;

var Eq = A.Eq;

var Ord = A.Ord;

var Show = A.Show;

var Invariant = A.Invariant;

var Extend = A.Extend;

var Infix = A.Infix;

exports.zip_with = zip_with;
exports.zip = zip;
exports.Functor = Functor;
exports.Alt = Alt;
exports.Apply = Apply;
exports.Applicative = Applicative;
exports.Monad = Monad;
exports.Foldable = Foldable;
exports.Unfoldable = Unfoldable;
exports.Traversable = Traversable;
exports.Eq = Eq;
exports.Ord = Ord;
exports.Show = Show;
exports.Invariant = Invariant;
exports.Extend = Extend;
exports.Infix = Infix;
/* A Not a pure module */
